import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import { addNewChat } from 'modules/chats';
import { viewUserProfile } from 'modules/app';
import { updateProfile } from 'routes/Profile/modules/actions';
import UserCard from '../components/UserCard';

function mapStateToProps(state) {
  return {
    literals: state.i18n.literals.userCard || {},
    app: state.app,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    addNewChat: bindActionCreators(addNewChat, dispatch),
    viewUserProfile: bindActionCreators(viewUserProfile, dispatch),
    updateProfile: bindActionCreators(updateProfile, dispatch),
  };
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(UserCard));



// WEBPACK FOOTER //
// ./src/components/Steps/UserCard/container/index.js